import { useContext } from 'react';

import PredefinedParamsContext, { PredefinedParamsContextValues } from './context';

const usePredefinedParams = (): PredefinedParamsContextValues =>
  useContext(PredefinedParamsContext);

export default usePredefinedParams;
